import React, { Component } from 'react'
import {List, Flex, Toast} from 'antd-mobile'
import { ORG_CODE, FARM_ORG } from '../../cache'
import Breeder from './components/breeder'
import LinkText from './components/link'
import DatePicker from '../../components/DatePicker'
import { dateToWeek } from '../../utils/weekToDate'
import df from 'dateformat'
import './index.css'
import Table from '../../components/Table';
import send from '../../utils/send';
import EmptyReport from "../../components/EmptyReport";
let breedersSource = [];
class Report03 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDatePicker: false,
      showBreeder: false,
      type: 'month',
      selectedBreeder: [],
      allBreed: 'ALL',
      startDate: new Date(),
      endDate: new Date(),
      startWeek: '',
      endWeek: '',
      columns: [{
        'id': 'sub_category_name_loc',
        'title': '按期间分析',
        'width': 100,
        'align': 'left',
        'fixed': true
      }],
      tableData: []
    }
  }
  UNSAFE_componentWillMount() {
    // type === MONTH 时， 开始日期默认为 当前日期往前推 10 个月
    if (this.state.type === 'month') {
      let day = new Date().getDate();
      let year = new Date().getFullYear();
      let month = new Date().getMonth();
      if (month < 10) {
        month = month + 1 - 10
      }
      let startDate = new Date(year, month, day);
      this.setState({startDate})
    }
    //  type === WEEK 退10周
    if (this.state.type === 'week') {
      let endWeek = dateToWeek(new Date());
      let time = new Date().getTime() - 24 * 60 * 60 * 1000 * 7 * 9; // 后退 10周
      console.log('time', df(time, 'yyyy-mm-dd'));
      let startWeek = dateToWeek(new Date(time));
      let startDate = new Date(time);
      this.setState({
        startWeek,
        endWeek,
        startDate
      })
    }
  }

  async componentDidMount() {
    let breed = await send({
      url: '/api/forward/ifarm/breedTypeByOrg',
      method: 'GET',
      params: {
        orgCode: ORG_CODE
      }
    });
    // 获取品种， 周次的信息，并默认初始值。得到之后，查询。
    breedersSource = breed.data.filter(o => o.PRODUCTID !== 'TOTAL');
    this.setState({
      selectedBreeder: breedersSource.map(o => o.PRODUCTID),
      allBreed: 'ALL'
    }, () => {
      this.doSearch()
    })
  }

  changeBreeder = () => {
    const {showBreeder} = this.state;
    this.setState({
      showBreeder: !showBreeder,
      showBirthWeek: false,
      showPreWeek: false
    })
  };
  onCancel = () => {
    this.setState({
      showBreeder: false
    })
  };
  doSearch = () => {
    const {type,startDate, endDate,startWeek,endWeek, selectedBreeder, allBreed} = this.state;
    Toast.loading('请稍候', 0);
    // 品种，是否是全部
    let parEndBreed = selectedBreeder.toString();
    if (allBreed === 'ALL') {
      parEndBreed = 'TOTAL'
    }
    // 计算后退周 后退月
    let backWeeks = 0;
    // reportType
    let reportType = 'PARITY_W';
    if (type === 'month') {
      reportType = 'PARITY_M';
      let startMonth = new Date(startDate).getMonth();
      let endMonth = new Date(endDate).getMonth();
      let yMonth = (new Date(endDate).getFullYear() - new Date(startDate).getFullYear()) * 12; // 一年12个月
      backWeeks = (endMonth - startMonth) + yMonth + 1
    }
    if (type === 'week') {
      reportType = 'PARITY_W';
      backWeeks = this.weekDiff(startWeek, endWeek)
    }
    send({
      url: '/api/forward/ifarm/report2',
      method: 'POST',
      data: {
        farmOrg: FARM_ORG,
        orgCode: ORG_CODE,
        parAllBreed: allBreed,
        parBackPeriodWeeks: backWeeks,
        parDate: df(endDate, 'yyyy-mm-dd'),
        parEndBreed: parEndBreed,
        parReportType: reportType,
        parStartBreed: '0'
      }
    }).then(res => {
      let tableData = res.data;
      console.log(tableData.map(o => o.column_acm_01));
      if (res.status !==200 || !(res.data instanceof Array)) {
        return
      }
      let columns = [
        {
          id: 'sub_category_name_loc',
          title: '按期间分析',
          align: 'left',
          fixed: true,
          render: (data, index) => {
            if (tableData[index]['sub_category_name_loc']) {
              let rang = ['10.1000', '20.0000', '20.1000', '30.0000','30.1000','40.0000','40.1000'];
              let fontWeight = rang.indexOf(tableData[index].sub_category) >= 0 ? '700' : '400';
              let color = rang.indexOf(tableData[index].sub_category) >= 0 ? '#000' : '#666';
              return <div style={{width: 100,fontWeight, color}}>{tableData[index]['sub_category_name_loc']}</div>
            } else {
              return ''
            }
          }
        }
      ];
      for (var i = 1; i < 200; i++) {
        let num = i < 10 ? '0' + i : i;
        let max = 'date_column_' + num + '_max_date';
        let min = 'date_column_' + num + '_min_date';
        let str = 'column_' + i;
        if(tableData[0][max]) {
          columns.push({
            id: str,
            title: `${tableData[0][min]}\n${tableData[0][max]}`,
            render: (data) => {
              let rang = ['10.1000', '20.0000', '20.1000', '30.0000','30.1000','40.0000','40.1000'];
              if (rang.indexOf(data['sub_category']) < 0) {
                return <div style={{width: 70}}>{data[str]}</div>
              } else {
                return ''
              }
            }
          })
        }
      }
      columns.push({
        id: 'column_acm_01',
        title: '累计',
        render: (data, index) => {
          let rang = ['10.1000', '20.0000', '20.1000', '30.0000','30.1000','40.0000','40.1000'];
          if (rang.indexOf(data['sub_category']) < 0) {
            return <div style={{width: 70}}>{tableData[index]['column_acm_01']}</div>
          } else {
            return ''
          }
        }
      });
      this.setState({
        columns,
        tableData: res.data}, () => {
        Toast.hide()
      })
    })
  };
  weekDiff = (start,end) => {
    let backWeeks = 0;
    let startWeek = start;
    let endWeek = end;
    let start1 = startWeek.substr(0, 2);
    let start2 = startWeek.substr(2);
    let end1 = endWeek.substr(0, 2);
    let end2 = endWeek.substr(2);
    if (start1 === end1) {
      backWeeks = end2 *1  - start2 * 1
    } else if (end1 - start1 > 0) {
      let yD = (end1 - start1 - 1) * 52;
      let d1 = 52 - start2 * 1 + 1;
      let d2 = end2 * 1;
      backWeeks = yD + d1 + d2
    }
    return backWeeks
  };
  componentWillUnmount() {
    Toast.hide()
  }

  render() {
    const {type, showDatePicker,showBreeder,selectedBreeder, startDate,endDate} = this.state;
    let date = `${df(startDate, 'yyyy-mm-dd')}~${df(endDate, 'yyyy-mm-dd')}`;
    if (type === 'month') {
      date = `${df(startDate, 'yyyy-mm')}~${df(endDate, 'yyyy-mm')}`
    }
    return (
      <React.Fragment>
        <div className="oneH">
          <List>
            <Flex className={showBreeder? 'single-multi-menu-active' : ''}>
              <div className={'single-multi-top-nav-bar'}
                  style={{width: '35%'}}
              >
                <List.Item onClick={this.changeBreeder}>
                  <LinkText show={showBreeder}>品种</LinkText>

                </List.Item>
              </div>
              <div className={'single-multi-top-nav-bar'}
                  style={{width: '65%'}}
              >
                <List.Item onClick={() => {
                  this.setState({
                    showBreeder: false,
                    showDatePicker: true
                  })}
                }
                >
                  <LinkText>{date}</LinkText>
                </List.Item>
              </div>
            </Flex>
          </List>
          {
            showBreeder ? <div style={{position: 'absolute',zIndex: 180,width: '100%'}}>
              <Breeder data={breedersSource}
                  onCancel={this.onCancel}
                  onConfirm={(value, desc) => {
                         this.setState({
                           showBreeder: false,
                           selectedBreeder: value,
                           allBreed: desc
                         }, () => {
                           this.doSearch()
                         });
                       }}
                  value={selectedBreeder}
              />
            </div>: null
          }
          <DatePicker
              defaultValues={[startDate, endDate]}
              mode={['month', 'week']}
              onCancel={() => {
              this.setState({ showDatePicker: false })
            }}
              onConfirm={(start, end, type) => {
              let startDate = type === 'week' ? start.startDate : start;
              let endDate = type === 'week' ? end.endDate : end;
              let startWeek = dateToWeek(startDate);
              let endWeek = dateToWeek(endDate);
              this.setState({
                showDatePicker: false,
                type,
                startDate,
                endDate,
                startWeek,
                endWeek
              }, () => {
                this.doSearch()
              })

            }}
              visible={showDatePicker}
          />


          {showBreeder ? <div className="menu-mask"
              onClick={this.onMaskClick}
                         /> : null}


          {this.state.tableData.length > 0 ?
            <Table columns={this.state.columns}
                   data={this.state.tableData}
                   stripe
            />
            : <EmptyReport height={250} />}
        </div>

      </React.Fragment>
    )
  }
}

export default Report03
